import { notFound } from "@tanstack/react-router";

import { playReader } from "./data/play-route";

export async function readPlayShell({
  signal,
  href,
}: {
  signal?: AbortSignal | undefined;
  href: string;
}) {
  const { address, reader } = await playReader({
    signal,
    href,
    expectedRoute: "game.play",
  });
  const shell = await reader.publicShell(address);

  if (!shell) throw notFound();

  return shell;
}

export async function readPlayActivity({
  signal,
  href,
}: {
  signal?: AbortSignal | undefined;
  href: string;
}) {
  const { address, reader } = await playReader({
    signal,
    href,
    expectedRoute: "game.playActivity",
  });
  const activity = await reader.activity(address);

  if (!activity) throw notFound();

  return activity;
}

export async function readPlayEpisodes({
  signal,
  href,
}: {
  signal?: AbortSignal | undefined;
  href: string;
}) {
  const { address, reader } = await playReader({
    signal,
    href,
    expectedRoute: "game.playEpisodes",
  });
  const episodes = await reader.episodes(address);

  if (!episodes) throw notFound();

  return episodes;
}

export async function readPlayRequests({
  signal,
  href,
}: {
  signal?: AbortSignal | undefined;
  href: string;
}) {
  const { address, reader } = await playReader({
    signal,
    href,
    expectedRoute: "game.playRequests",
  });
  const requests = await reader.requests(address);

  if (!requests) throw notFound();

  return requests;
}
